import * as svg from "../../../assets/moon.svg";

import {iconBuilder} from "./iconBuilder";

export const MoonIcon = iconBuilder(svg, "MoonIcon", "0 0 10 10");
